const skeletonThree = [{ id: 1 }, { id: 2 }, { id: 3 }]
const skeletonFour = [...skeletonThree, { id: 4 }]
const skeletonFive = [...skeletonFour, { id: 5 }]
const newslineSkeleton = [
  { id: 1, type: 'COMMON' },
  { id: 2, type: 'COMMON' },
  { id: 3, type: 'COMMON' },
  { id: 4, type: 'COMMON' },
]
const skeletonLectors = [
  { id: 401 },
  { id: 502 },
  { id: 403 },
  { id: 404 },
  { id: 405 },
  { id: 406 },
  { id: 407 },
  { id: 408 },
  { id: 409 },
  { id: 410 },
]

export { skeletonThree, skeletonFour, skeletonFive, newslineSkeleton, skeletonLectors }
